import ReachOut from '../../Components/Landing/ReachOut'
import { useEffect, useState } from 'react'
import { showLoader } from '../../Redux/Slices/loaderSlice'
import { get_posts_public, getallpress_public, getallpressandmediacoverage_public } from '../../Redux/Actions/action'
import { useDispatch } from 'react-redux'
import { BucketURL } from '../../ApiSetup/Api'
import { Box, Grid, Typography } from '@mui/material'
import CommonContainer from '../../Components/Landing/CommonContainer'

const PressAndMedia = () => {
    const dispatch = useDispatch()
    const [bgImage, setBgImage] = useState([])
    const [pressAndMediaCoverage, setPressAndMediaCoverage] = useState("")
    const [pressData, setPressData] = useState([])

    const fetchData = async (params, setter) => {
        dispatch(showLoader(true));
        try {
            const res = await dispatch(get_posts_public(params));
            setter(res.payload.data.data);
            dispatch(showLoader(false));
        } catch (err) {
            dispatch(showLoader(false));
        }
    };

    const _getallpressandmediacoverage = async () => {
        dispatch(showLoader(true));
        try {
            const res = await dispatch(getallpressandmediacoverage_public({}));
            setPressAndMediaCoverage(res.payload?.data?.response?.[0]?.description);
            dispatch(showLoader(false));
        } catch (err) {
            dispatch(showLoader(false));
        }
    };

    const _getallpress = async () => {
        dispatch(showLoader(true));
        try {
            const res = await dispatch(getallpress_public({}));
            setPressData(res.payload?.data?.response);
            dispatch(showLoader(false));
        } catch (err) {
            dispatch(showLoader(false));
        }
    };

    useEffect(() => {
        fetchData(
            {
                type: 'Hero-Banner', status: 'Active', page: 1,
            },
            setBgImage
        );
        _getallpressandmediacoverage()
        _getallpress()
    }, []);

    return (
        <div>
            <Box>
                {bgImage?.map((item, index) => (
                    <Box key={index} sx={{ position: 'relative' }}>
                        <img
                            src={BucketURL + item.heroBannerDetails?.bannerImage}
                            alt={item.heroBannerDetails?.eventName || 'Hero Banner'}
                            style={{ filter: 'brightness(0.3)', width: '100%', objectFit: 'cover', maxHeight: '320px' }}
                        />
                        <Box sx={{
                            position: 'absolute', zIndex: 1, top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)', textAlign: 'center', color: "#fff",
                            maxWidth: '1200px', width: '100%'
                        }} >
                            <Typography
                                sx={{
                                    fontSize: { lg: "34px", md: "20px", sm: "16px", xs: "16px" },
                                    fontWeight: "bold",
                                }}
                            >
                                Press & Media
                            </Typography>
                            <Typography fontWeight={"normal"} sx={{
                                fontSize: { lg: "16px", md: "14px", sm: "13x", xs: "12px" },

                            }} >Patidar Parivar Suraksha Kavach is a community-driven initiative providing security, care, and sahaynidhi support for Patidar families worldwide. Our programs address health, family, and unexpected challenges while fostering unity, compassion, and peace of mind.</Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
            <CommonContainer>
                <Typography
                    color={"primary"}
                    sx={{
                        fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
                        fontWeight: "400",
                    }}
                >
                    Press & Media Coverage
                </Typography>
                <Typography
                    sx={{
                        fontSize: { lg: "20px", md: "16px", sm: "16px", xs: "12px" },
                        color: "#4b4c4c",
                        fontWeight: '200',
                        mb: 3
                    }}
                >
                    Patidar Parivar Suraksha Kavach (PPSK) has been widely recognized in press and media for its dedication to strengthening the Patidar community. With sahaynidhi programs and welfare initiatives, PPSK ensures that families receive timely support in times of health crises, family needs, and unforeseen challenges. Its mission of care and security has been highlighted as a model of community-driven impact.
                </Typography>
                <div dangerouslySetInnerHTML={{ __html: pressAndMediaCoverage }} />
            </CommonContainer>
            <CommonContainer>
                <Box
                    sx={{ mb: { lg: 3, mg: 3, sm: 2, xs: 1 } }}
                >
                    <Typography
                        color={"primary"}
                        sx={{
                            fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "26px" },
                            fontWeight: "400",
                        }}
                    >
                        Press
                    </Typography>
                </Box>
                <Grid container spacing={{ lg: 3, md: 2, sm: 2, xs: 1 }}>
                    {pressData?.map((item) => {
                        return (
                            <Grid item lg={3} md={4} sm={6} xs={12} style={{ position: 'relative' }}>
                                <Box sx={{ padding: "15px", backgroundColor: '#deedee', borderRadius: '20px' }}>
                                    <Box
                                        component="img"
                                        src={BucketURL + item?.image}
                                        alt={"image"}
                                        sx={{
                                            width: "100%",
                                            height: {
                                                lg: 250,
                                                md: 200,
                                                sm: 200,
                                                xs: 200,
                                            },
                                            objectFit: "cover",
                                            borderRadius: "12px",
                                            display: "block",
                                        }}
                                        loading="lazy"
                                    />
                                    <Box mt={1}>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontSize: {
                                                    lg: "24px",
                                                    md: "16px",
                                                    sm: "16px",
                                                    xs: "16px",
                                                },
                                                fontWeight: "normal",
                                                lineHeight: '25px'
                                            }}
                                        >
                                            {item?.title?.slice(0, 68) + "..."}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        )
                    })}
                </Grid>
            </CommonContainer>
            <ReachOut />
        </div>
    )
}

export default PressAndMedia
